export default __webpack_public_path__ + "static-front/media/WaveIcon.9ba8cc62.svg";